<button
  class="store-switcher"
  mat-icon-button
  [matMenuTriggerFor]="storeMenu"
  attr.aria-label="{{ 'Change the language' | translate | async }}"
>
  {{ currentStore.code | uppercase }}
  <mat-icon>expand_more</mat-icon>
</button>
<mat-menu #storeMenu="matMenu">
  @for (store of stores; track store) {
    <button
      mat-menu-item
      (click)="setCurrentStore(store)"
      [ngClass]="store.code === currentStore.code ? 'font-weight-bold' : ''"
    >
      {{ store.code | uppercase }}
    </button>
  }
</mat-menu>
